var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-inner-loading',{staticClass:"z-fullscreen text-mq-magenta",attrs:{"visible":_vm.visible,"color":"mq-magenta"}},[_c('q-spinner-rings',{attrs:{"size":"90px","color":"mq-magenta"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }